module.exports = __webpack_public_path__ + "Lato-HairlineItalic.a567f4a8e101cb600004";


//////////////////
// WEBPACK FOOTER
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/assets/fonts/Lato/Lato-HairlineItalic.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-HairlineItalic.ttf
// module chunks = styles